import { Molecule, wrap } from 'AppReact';
import styled from 'styled-components';
import { Mt2, FlexCenterWrapper, Mr2, } from 'wrappers';
import { SecondaryTextSm, SecondaryTextSmBold, CustomText, Icon } from 'atoms';
import { textEllipsis } from 'utils/ellipsis';
import { priorityList, getIconByName } from 'utils';

const template = styled.div`
`;

export default Molecule({
  template,
  atoms: [
    {
      wrapper: FlexCenterWrapper,
      name: 'TopRow',
      atoms: [
        {
          component: wrap(CustomText, Mr2),
          name: 'CallBack',
          renderIf: ({ order }) => order?.is_callback && order.status !== 'completed',
          displayValue: ({ }) => 'CALLBACK',
          displayState: ({ }) => ({ color: '#E6B300', fontSize: '12px', fontWeight: 600, letterSpacing: '0.72px' })
        },
        {
          component: wrap(CustomText, Mr2),
          name: 'Level',
          renderIf: ({ order }) => order.level && order.level !== 'regular',
          displayValue: ({ order }) => order.level_display ? order.level_display?.toUpperCase() : '',
          displayState: ({ order }) => {
            let priority = priorityList.find(priority => priority.level === order.level)
            return { fontSize: '12px', color: priority?.textColor, fontWeight: 600, letterSpacing: '0.72px' }
          },
        },
        {
          component: wrap(Icon, Mr2),
          name: 'NoAccess',
          renderIf: ({ order }) => order.status !== 'completed' && order.mark_no_access,
          displayValue: ({ }) => getIconByName({ name: 'Lock', width: 15, height: 15 }),
        },
        {
          component: wrap(Icon, Mr2),
          name: 'WaitingOnParts',
          renderIf: ({ order }) => order.status !== 'completed' && order.waiting_on_parts,
          displayValue: ({ }) => getIconByName({ name: 'SingleHammer', width: 15, height: 15 }),
        },
        {
          component: SecondaryTextSmBold,
          name: 'Category',
          displayValue: ({ order }) => order.is_callback && order.level !== 'regular' ? textEllipsis(order?.category_name ?? '', 10) : order?.category_name ?? '',
        },
      ]
    },
    {
      component: wrap(SecondaryTextSm, Mt2),
      name: 'CategoryParent',
      displayValue: ({ order, selectedTab }) => textEllipsis((order?.creation_note) ?? '', 35),
    },
  ],
});
